import { render, staticRenderFns } from "./EditOpeningHoursPolicyLimit.vue?vue&type=template&id=76e38100&"
import script from "./EditOpeningHoursPolicyLimit.vue?vue&type=script&lang=js&"
export * from "./EditOpeningHoursPolicyLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports